import {
  CreateGUFStartRegistrationTask,
  EditGUFStartRegistrationTask,
} from "@nens/brostar/uploadapi-client";

import { addSchema } from "@/helpers/schema-utils";

import { pickGufPrimitiveLibraryFields } from "../guf-schema-primitive-library";

import { designScreenSchema } from "./guf-design-screen-schema";

/**
 * Schema for DesignWell within a DesignInstallation
 */
export const designWellSchema = addSchema<
  (
    | CreateGUFStartRegistrationTask
    | EditGUFStartRegistrationTask
  )["sourcedocumentData"]["designInstallations"][number]["designWells"]
>({
  type: "array",
  title: "Ontwerpputten",
  minItems: 0,
  items: {
    type: "object",
    title: "Ontwerpput",
    required: ["designWellId", "wellFunctions", "height", "wellPos"],
    properties: {
      ...pickGufPrimitiveLibraryFields([
        "designWellId",
        "wellFunctions",
        "height",
        "wellPos",
        "geometryPubliclyAvailable",
        "maximumWellDepth",
        "maximumWellDepthPubliclyAvailable",
        "maximumWellCapacity",
        "relativeTemperature",
      ]),
      designScreen: designScreenSchema,
    },
  },
});
